import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from "vue";
  import BuilderEstimatorStepTitle from "@/components/builder/estimator-tool/BuilderEstimatorStepTitle.vue";
  import CustomizeHouseSlider from "@/components/builder/CustomizeHouseSlider.vue";
  import BuilderSliderButtons from "@/components/builder/BuilderSliderButtons.vue";
  import { useIsDesktop } from "@/features/useIsDesktop";
  import BuilderSliderImages from "@/components/builder/BuilderSliderImages.vue";
  import formateEntityForBuilderSliderImagesInterface from "@/helpers/builder/formateEntityForBuilderSliderImagesInterface";
  import SelectionInstruction from "./SelectionInstruction.vue";
  import {
    BuilderEstimatorStyleOption,
    StyleOption,
  } from "@/types/BuilderEstimatorStyleOption";
  import {
    FacadeInterface,
    FacadeInterfaceWithImagesUrls,
  } from "@/types/FacadeInterface";
  import {
    ColorSchemeInterface,
    ColorSchemeInterfaceWithImagesUrls,
  } from "@/types/ColorSchemeInterface";
  import { sortByPriceAscending } from "@/helpers/sortByPriceAscending";
  import { formatPrice } from "@/helpers/transformation/price";
  import BuilderEstimatorSelectionHouseMobile from "./builder-estimator-selection-house/BuilderEstimatorSelectionHouseMobile.vue";

  interface Props {
    sliderOptions:
      | FacadeInterfaceWithImagesUrls[]
      | ColorSchemeInterfaceWithImagesUrls[];
    instructions: {
      title: string;
      description: string;
    };
    selectedHouseStyle: StyleOption | null;
    isInternalColor: boolean;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderEstimatorSelectionHouseStyle',
  props: {
    sliderOptions: {},
    instructions: {},
    selectedHouseStyle: {},
    isInternalColor: { type: Boolean, default: false }
  },
  emits: ["onSelectOptionStyle"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;

  const props = __props;

  const { isDesktop } = useIsDesktop(990);

  const sliderImages = ref<string[]>([]);
  const styleSelected = ref<StyleOption | null>(null);

  const onSelectOptionStyle = (option: StyleOption) => {
    styleSelected.value = option;
    setSliderImages();
    emits("onSelectOptionStyle", option);
  };

  const setSliderImages = () => {
    if (props.isInternalColor) {
      const selectedImage = styleSelected?.value?.imagesUrls;
      const imagesOptions = props.sliderOptions[0].imagesUrls;

      sliderImages.value = selectedImage ? selectedImage : imagesOptions;
    } else {
      const selectedImage = styleSelected?.value?.imagesUrls[0];
      const imagesOptions = props.sliderOptions.map(
        (option) => option.imagesUrls[0]
      );

      sliderImages.value = selectedImage ? [selectedImage] : imagesOptions;
    }
  };

  const sliderContentTitle = computed(() => {
    return `Swipe to compare ${props.instructions.title}s`;
  });

  watch(
    props.sliderOptions,
    () => {
      if (!props.sliderOptions) return;

      setSliderImages();
    },
    { deep: true, immediate: true }
  );

  watch(
    () => props.selectedHouseStyle,
    (newVal) => {
      if (!newVal) return;

      styleSelected.value = newVal;
      setSliderImages();
    },
    { deep: true, immediate: true }
  );

const __returned__ = { emits, props, isDesktop, sliderImages, styleSelected, onSelectOptionStyle, setSliderImages, sliderContentTitle, computed, ref, watch, BuilderEstimatorStepTitle, CustomizeHouseSlider, BuilderSliderButtons, get useIsDesktop() { return useIsDesktop }, BuilderSliderImages, get formateEntityForBuilderSliderImagesInterface() { return formateEntityForBuilderSliderImagesInterface }, SelectionInstruction, get BuilderEstimatorStyleOption() { return BuilderEstimatorStyleOption }, get StyleOption() { return StyleOption }, get FacadeInterface() { return FacadeInterface }, get FacadeInterfaceWithImagesUrls() { return FacadeInterfaceWithImagesUrls }, get ColorSchemeInterface() { return ColorSchemeInterface }, get ColorSchemeInterfaceWithImagesUrls() { return ColorSchemeInterfaceWithImagesUrls }, get sortByPriceAscending() { return sortByPriceAscending }, get formatPrice() { return formatPrice }, BuilderEstimatorSelectionHouseMobile }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})